import {PAY_CONNECT_CDN_LOGOS} from '../constants/payConnectCdnLogos'

export type PaymentPurpose = 'subscription' | 'service_fee' | 'template'

export type GatewayFactoryName =
  | 'PY_WHISH'
  | 'PY_BLOM_UC'
  | 'PY_BLOM'
  | 'PY_OMT'
  | 'PY_CASH'
  | string

export type GatewayDisplay = {
  nameKey: string
  descriptionKey: string
  flowInfoKey: string
  /** Official remote logo URL (preferred). */
  iconSrc: string
  /** Fallback if primary fails (same CDN — local /payment-gateways assets are absent). */
  iconFallbackSrc: string
  logoWidth: number
  logoHeight: number
}

const LOGO_W = 120
const LOGO_H = 60

/** Official CDN logos — forced to 120×60 via object-fit contain. */
export const GATEWAY_DISPLAY: Record<string, GatewayDisplay> = {
  PY_WHISH: {
    nameKey: 'gatewayWhishName',
    descriptionKey: 'gatewayWhishDescription',
    flowInfoKey: 'gatewayFlowInfoWhish',
    iconSrc: PAY_CONNECT_CDN_LOGOS.PY_WHISH,
    iconFallbackSrc: PAY_CONNECT_CDN_LOGOS.PY_WHISH,
    logoWidth: LOGO_W,
    logoHeight: LOGO_H,
  },
  PY_BLOM_UC: {
    nameKey: 'gatewayBlomName',
    descriptionKey: 'gatewayBlomDescription',
    flowInfoKey: 'gatewayFlowInfoBlom',
    iconSrc: PAY_CONNECT_CDN_LOGOS.PY_BLOM_UC,
    iconFallbackSrc: PAY_CONNECT_CDN_LOGOS.PY_BLOM_UC,
    logoWidth: LOGO_W,
    logoHeight: LOGO_H,
  },
  PY_BLOM: {
    nameKey: 'gatewayBlomName',
    descriptionKey: 'gatewayBlomDescription',
    flowInfoKey: 'gatewayFlowInfoBlom',
    iconSrc: PAY_CONNECT_CDN_LOGOS.PY_BLOM_UC,
    iconFallbackSrc: PAY_CONNECT_CDN_LOGOS.PY_BLOM_UC,
    logoWidth: LOGO_W,
    logoHeight: LOGO_H,
  },
  PY_OMT: {
    nameKey: 'gatewayOmtName',
    descriptionKey: 'gatewayOmtDescription',
    flowInfoKey: 'gatewayFlowInfoOmt',
    iconSrc: PAY_CONNECT_CDN_LOGOS.PY_OMT,
    iconFallbackSrc: PAY_CONNECT_CDN_LOGOS.PY_OMT,
    logoWidth: LOGO_W,
    logoHeight: LOGO_H,
  },
  PY_CASH: {
    nameKey: 'gatewayCashName',
    descriptionKey: 'gatewayCashDescription',
    flowInfoKey: 'gatewayFlowInfoCash',
    iconSrc: '/payment-gateways/py_cash.png',
    iconFallbackSrc: '/payment-gateways/py_cash.png',
    logoWidth: LOGO_W,
    logoHeight: LOGO_H,
  },
}

export function getGatewayDisplay(factoryName: string): GatewayDisplay {
  return (
    GATEWAY_DISPLAY[factoryName] || {
      nameKey: factoryName,
      descriptionKey: '',
      flowInfoKey: '',
      iconSrc: `/payment-gateways/${factoryName.toLowerCase()}.png`,
      iconFallbackSrc: `/payment-gateways/${factoryName.toLowerCase()}.png`,
      logoWidth: LOGO_W,
      logoHeight: LOGO_H,
    }
  )
}

export type CheckoutSummary = {
  titleKey?: string
  planName?: string
  priceLabel?: string
  durationLabel?: string
  startDateLabel?: string
  description?: string
  imageSrc?: string
}
